import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

const udpBindConnectionConfigSchema = z.object({
    useBind: z.literal(true),
    // there isnt really such thing as a "UDP client", but we can kind of get there by storing the address/ port of anything that sends us udp data
    // as we build up this list it is important to clear it eventually, max timeout is 1 day
    clientTimeoutMs: z.number().min(0).max(86400000),
});

const udpStandardConnectionConfigSchema = z.object({
    ip: z.string(),
    useBind: z.literal(false),
});

export const udpSocketConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.UdpSocket),
    details: z.object({
        port: z.number(),
        bind: z.discriminatedUnion('useBind', [
            udpBindConnectionConfigSchema,
            udpStandardConnectionConfigSchema,
        ]),
    }),
});
export type UdpSocketConnectionConfig = z.infer<typeof udpSocketConnectionConfigSchema>;
